import Converter from './Converter';
import { CasinoType, ICasinoProviderConfigurationItem } from 'modules/Casino/types/configuration';
import { projectName } from 'modules/Casino/utils/slots';
import { QueryTypes } from 'modules/Casino/types/enums/api';
import { parseCookies } from '../../utils/parseCookies';
import { shortLanguages } from 'services/locale';

const converter = new Converter();

export const config: ICasinoProviderConfigurationItem<Converter> = {
  type: CasinoType.slots,
  gameListUrl: 'rgs2galaxsys/game/list',
  converter,
  gameListUrlData: {
    getHeaders: () => ({
      'Content-Type': 'application/json',
      headers: {
        'x-partner-authorization': parseCookies(),
        'x-partner-name': projectName,
      },
    }),
  },
  sessionUrlData: {
    url: 'rgs2galaxsys/game/launch',
    method: QueryTypes.GET,
    converter: converter.convertGameUrl,
    getQuery: params => {
      const deviceType = params.isDesktop ? 1 : 2;

      return `?game_id=${params.gameId}&play_mode=1&device_type=${deviceType}&language=${
        shortLanguages[params.lang as keyof typeof shortLanguages] ?? shortLanguages['es-es']
      }`;
    },
    getHeaders: () => ({
      'Content-Type': 'application/json',
      headers: {
        'x-partner-authorization': parseCookies(),
        'x-partner-name': projectName,
      },
    }),
  },
};
